import { render, staticRenderFns } from "./AdminBranches.vue?vue&type=template&id=61ba7d2a&"
import script from "./AdminBranches.vue?vue&type=script&lang=js&"
export * from "./AdminBranches.vue?vue&type=script&lang=js&"
import style0 from "./AdminBranches.vue?vue&type=style&index=0&id=61ba7d2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports